export default __webpack_public_path__ + "static/media/17@3x.83fb0a37.png";